import { render, staticRenderFns } from "./ErrorHandlerScreening.vue?vue&type=template&id=6d677c56&scoped=true&"
import script from "./ErrorHandlerScreening.vue?vue&type=script&lang=js&"
export * from "./ErrorHandlerScreening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d677c56",
  null
  
)

export default component.exports